<div *withPermissions="let allow of ['CanInsertTickets']" class="row">
	<div class="col-md-12">
		<div class="card">
			<div class="card-header">
				Open Tickets
				<button [hidden]="!allow().CanInsertTickets()" (click)="newTicket()" class="btn btn-primary float-end">
					<i class="fa fa-plus"></i>
					New Ticket
				</button>
				<button (click)="loadTickets()" style="margin-right: 5px;" class="btn btn-primary float-end">
					<i class="fas fa-sync"></i>
					Refresh
				</button>
			</div>
			<div [loadingOverlay]="isLoading" class="card-body">
				@if (!isLoading) {
					<app-table [items]="tickets" [exportFilename]="'open-tickets'">
						<ng-template #tableHeader>
							<tr>
								<th export sort field="TicketTypeName">Ticket Type</th>
								<th export sort field="StartDate">Next Action Date</th>
								<th export sort field="SlaDate">SLA Date</th>
								<th export sort field="AssignedUserName">Assigned User</th>
							</tr>
						</ng-template>
						<ng-template #tableBody let-ticket>
							<tr>
								<td>
									<div class="row">
										<div class="col-md-10">
											<button (click)="editTicket(ticket)" class="btn btn-primary">
												<i class="fas fa-external-link-square-alt"></i>
												<span>{{ticket.TicketTypeName}}</span>
											</button>
										</div>
										@if (ticket.LatestNote) {
											<div class="col-md-2 text-end">
												<div>
													<span [ngbPopover]="ticket.LatestNote.Text.substring(0, 400)" [popoverTitle]="'Latest Note (' + moment(ticket.LatestNote.InsertedDate).format('MM/DD/YYYY') + ')'" placement="right auto" triggers="mouseenter:mouseleave">
														<i class="fa fa-sticky-note fa-2x text-info"></i>
													</span>
												</div>
											</div>
										}
									</div>
								</td>
								<td>{{ticket.StartDate | dateText: 'M/DD/YYYY h:mm a' : false }}</td>
								<td [class.text-danger]="ticket.SlaDate < Date.now()">{{ticket.SlaDate | dateText: 'M/DD/YYYY h:mm a' : false }}</td>
								<td>{{ticket.AssignedUserName}}</td>
							</tr>
						</ng-template>
					</app-table>
				}
			</div>
		</div>
	</div>
</div>
